import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import OpalCard from '../../../../components/opal/OpalCard'

function LinkCard ({ to, children, className }) {
  return (
    <Link className={clsx('dai-link-card rich', className)} to={to}>
      <OpalCard
        className='font-serif p-lg opal-selectable relative'
        style={{ backgroundColor: 'var(--dai-color-surface3)' }}
      >
        {children}
      </OpalCard>
    </Link>
  )
}

LinkCard.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}

export default LinkCard
